export class DayReport {
    public email: string = "";
    public empName: string = "";
    public month: string = "";
    public weekNo: string = "";
    public projNo: string = "";
    public taskNo: string = "";
    public day: string = "";
    public hours: number = 0;
    public projName: string = "";
    public taskName: string = "";
    public expType: string = "";
    public isSubTotalRow: boolean = false;

    constructor(reportData?: any) {
        if (reportData === null) return;
        this.email = reportData["email"];
        this.empName = reportData["empName"];
        this.month = reportData["month"];
        this.weekNo = reportData["weekNo"];
        this.projNo = reportData["projNo"];
        this.taskNo = reportData["taskNo"];
        this.day = reportData["day"] !== null ? reportData["day"].split('T')[0] : '';
        this.hours = reportData["hours"];
        this.projName = reportData["projName"];
        this.taskName = reportData["taskName"];
        this.expType = reportData["expType"];
    }

    static fromJSONArray(data: Array<any>): DayReport[] {
        return data.map(item => new DayReport(item));
    }    
}
